<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">history</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Histórico da série</h2>
    <span class="modal-subtitle">{{ data.numeroSerie }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <div class="list-container">
    @if (loading && lista.length === 0) {
      <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (lista.length === 0) {
      <p class="empty-text">Nenhuma movimentação encontrada para esta série.</p>
    } @else {
      <table class="table">
        <thead>
          <tr>
            <th>Data / Hora</th>
            <th>Operação</th>
            <th>Origem</th>
            <th>Usuário</th>
            <th class="text-end">Qtd</th>
            <th class="text-end">Saldo</th>
          </tr>
        </thead>
        <tbody>
          @for (item of lista; track item.dataHora) {
            <tr>
              <td>{{ item.dataHora | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td>
                <span class="status-badge" [class.badge-verde]="item.quantidade > 0"
                  [class.badge-vermelho]="item.quantidade < 0"
                  [class.badge-cinza]="item.quantidade === 0">{{ item.descricaoOperacao }}</span>
              </td>
              <td>{{ item.descricaoOrigem }}</td>
              <td>{{ item.usuarioResponsavel }}</td>
              <td class="text-end" [ngClass]="{'text-danger': item.quantidade < 0, 'text-success': item.quantidade > 0}">
                {{ item.quantidade > 0 ? '+' : '' }}{{ item.quantidade }}
              </td>
              <td class="text-end">{{ item.saldo }}</td>
            </tr>
          }
        </tbody>
      </table>

      @if (lista.length < total) {
        <div class="load-more-container">
          <button mat-stroked-button (click)="loadMore()" [disabled]="loading">
            {{ loading ? 'Carregando...' : 'Ver Mais' }}
          </button>
        </div>
      }
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
